import React from "react";
import { ArrowRight, Check, MapPin } from "lucide-react";
import { TspCard } from "../../../components/primitives";
import { formatDate } from "../../../utils/tspFormat";

// Displays the journey's planned route as a connected horizontal path:
// Place 1 ───► Place 2 ───► Place 3 ───► Place 4
// Dynamically updates as places are added, removed, or reordered on Add, Edit, and Update Journey pages.
export default function JourneyRoutePlanCard({ places = [], className = "" }) {
  const count = places.length;

  return (
    <TspCard
      title="Route Plan"
      className={`tsp-route-plan-card ${className}`.trim()}
      action={
        count > 0 ? (
          <span className="tsp-status-pill tsp-status-pill-muted">
            <MapPin size={11} aria-hidden="true" /> {count} {count === 1 ? "Place" : "Places"}
          </span>
        ) : null
      }
    >
      {count === 0 ? (
        <p className="tsp-muted-text tsp-route-plan-empty">
          No places added to the route yet. Add places below to build your route plan.
        </p>
      ) : (
        <div className="tsp-route-plan-container">
          <div className="tsp-route-plan-flow" role="list" aria-label="Journey Route Flow">
            {places.map((place, index) => {
              const isLast = index === count - 1;
              const name = place.cityName || place.city || place.name || (place.label ? place.label.split(",")[0].trim() : `Place ${index + 1}`);
              const state = place.stateName || place.state || "";
              const rawDate = place.plannedDate || place.planned_date || place.date || place.first_visit_date || "";
              const dateText = rawDate ? formatDate(rawDate) : (place.dateRange || "");
              const status = place.status;
              const isCompleted = status === "completed";
              const isLive = status === "live";

              return (
                <React.Fragment key={place.id || place.key || `${name}-${index}`}>
                  <div className={`tsp-route-plan-step ${isCompleted ? "is-completed" : ""} ${isLive ? "is-live" : ""}`.trim()} role="listitem">
                    <div className="tsp-route-plan-badge" aria-hidden="true">
                      {isCompleted ? <Check size={11} strokeWidth={2.5} /> : <span>{index + 1}</span>}
                    </div>
                    <div className="tsp-route-plan-info">
                      <span className="tsp-route-plan-name" title={state ? `${name}, ${state}` : name}>
                        {name}
                      </span>
                      {dateText && <span className="tsp-route-plan-date">{dateText}</span>}
                    </div>
                  </div>
                  {!isLast && (
                    <div className="tsp-route-plan-connector" aria-hidden="true">
                      <span className="tsp-route-plan-line" />
                      <ArrowRight size={12} className="tsp-route-plan-arrow" />
                    </div>
                  )}
                </React.Fragment>
              );
            })}
          </div>
        </div>
      )}
    </TspCard>
  );
}
